<template>
  <BaseWrapper :loading="loading">
    <div class="space-y-4">
      <ul v-if="breadcrumbs.length" class="flex items-center space-x-4">
        <li>
          <div>
            <a href="#" class="text-gray-400 hover:text-gray-500" @click="onResetBreadcrumb">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </a>
          </div>
        </li>
        <li v-for="breadcrumb in breadcrumbs" :key="breadcrumb.id">
          <div class="flex items-center space-x-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0 text-gray-400" fill="none"
              viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
            </svg>
            <a href="#" class="text-sm font-medium text-gray-500 hover:text-gray-700"
              @click="onClickBreadcrumb(breadcrumb)">{{ breadcrumb.attributes.name }}</a>
          </div>
        </li>
      </ul>
      <Datatable :columns="columns">
        <template v-slot:tbody="{ classes }">
          <Draggable tag="tbody" v-model="menus.data" @end="onChange">
            <tr v-for="menu in menus.data" :key="menu.id" :class="[classes.tr, 'bg-white border-b']">
              <td :class="[classes.td]">
                <div class="flex items-center gap-2">
                  <button>
                    <Icon icon="heroicons:bars-3" />
                  </button>
                  {{ menu.attributes.name }}
                </div>
              </td>
              <td :class="[classes.td]">
                <button v-if="menu.attributes.has_children" @click="onOpenChildren(menu)">
                  <Icon
                    :icon="childrenVisibles.includes(menu.id) ? 'heroicons:chevron-down' : 'heroicons:chevron-right'" />
                </button>
              </td>
            </tr>
          </Draggable>
        </template>
      </Datatable>
    </div>
  </BaseWrapper>
</template>

<script>
import { requestMixin } from '../../../../mixins/request/request';
import Draggable from 'vuedraggable'

export default {
  mixins: [requestMixin],
  components: { Draggable },
  data() {
    return {
      loading: true,
      breadcrumbs: [],
      menus: {
        data: []
      },
      childrenVisibles: []
    }
  },
  computed: {
    columns() {
      return [
        { id: 'name', name: 'Nama' },
        { id: 'action', name: '' }
      ]
    }
  },
  methods: {
    async loadMenus(parentId) {
      this.loading = true

      const [res, err] = await this.request(`/api/v1/menus`, {
        params: {
          'filter[office_type]': 'pusat',
          'filter[is_parent]': parentId ? null : true,
          'filter[parent_id]': parentId,
          'sort': 'order_no'
        }
      })

      if (!err) {
        this.menus = res
      }

      this.loading = false
    },
    onOpenChildren(menu) {
      this.breadcrumbs.push(menu);

      this.loadMenus(menu.id)
    },
    onResetBreadcrumb() {
      this.breadcrumbs = [];

      this.loadMenus();
    },
    async onClickBreadcrumb(menu) {
      const breadcrumbIndex = this.breadcrumbs.findIndex(
        (breadcrumb) => breadcrumb.id === menu.id
      );

      this.breadcrumbs.splice(
        breadcrumbIndex + 1,
        this.breadcrumbs.length - breadcrumbIndex + 1
      );

      this.loadMenus(menu.id);
    },
    async onChange() {
      this.loading = true

      const orders = this.menus.data.map((menu, i) => ({
        id: menu.id,
        name: menu.attributes.name,
        order: i + 1
      }))

      await this.request(`/api/v1/menus/-actions/update-orders`, {
        method: 'post',
        data: { orders }
      })

      this.loading = false
    }
  },
  created() {
    this.loadMenus()
  }
}
</script>